import { Map, OrderedSet } from 'immutable';

import { getDistance } from '../../utils';

export default {
  SET: type => {
    return (dispatch, getState) => {
      const store = getState();
      let currentHotels = store.getIn(['customer', 'current_hotels']);
      //ACTIVE LOYALTY
      currentHotels = currentHotels.filter(
        hotelID =>
          store.getIn(['hotels', hotelID, 'success'], false) &&
          store.getIn(
            [
              'avail',
              hotelID,
              store.getIn(['hotels', hotelID, 'params', store.getIn(["availQuery", "multi", "string_params"])]),
              'raw_response',
              0,
              'success'
            ],
            false
          )
      );

      const orderedHotels = OrderedSet(
        currentHotels.sort((a, b) => {
          const isStars = type === 'stars'; // Stars sort inverse (from major stars to minor)

          const getHotelDistance = _getHotelDistance(store);
          const getHotelAvgPrice = _getHotelAvgPrice(store);

          let comparerA, comparerB;

          switch (type) {
            case 'name':
            case 'stars':
              comparerA = store.getIn(['hotels', a, type]);
              comparerB = store.getIn(['hotels', b, type]);
              break;
            case 'proximity':
              comparerA = getHotelDistance(a);
              comparerB = getHotelDistance(b);
              break;
            case 'price':
            default:
              comparerA = getHotelAvgPrice(a);
              comparerB = getHotelAvgPrice(b);
          }

          if (comparerA > comparerB) {
            return isStars ? -1 : 1;
          } else if (comparerA < comparerB) {
            return isStars ? 1 : -1;
          } else {
            return 0;
          }
        })
      );

      return Map({
        type,
        orderedHotels
      });
    };
  }
};

const _getHotelDistance = store => hotelId => {
  const hotel = store.getIn(['hotels', hotelId]);
  const city = store.getIn(['hotels', 'hotels_info', 'cities']).find(city => city.get('id') === hotel.get('city_id'));
  return getDistance(city.get('latitude'), city.get('longitude'), hotel.get('latitude'), hotel.get('longitude'));
};
//ACTIVE LOYALTY
const _getHotelAvgPrice = store => hotelId => {
  const queryParams = store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "string_params"])]);
  const segment = store.getIn(['avail', hotelId, queryParams, 'raw_response']).first();

  if (segment && segment.get('success')) {
    const stayLength = store.getIn(['customer', 'params', 'params', 'stay_length']);
    const totalPrice = segment.getIn(['rooms', 0, 'boards', 0, 'price']) || 0;
    return totalPrice / stayLength;
  }

  return 0;
};
